// extracted by mini-css-extract-plugin
export default {"dashboard-container":"AdminUserBalance_dashboard-container__VIYDB","dashboard-title":"AdminUserBalance_dashboard-title__yAHIA","table-admin":"AdminUserBalance_table-admin__rBkD7"};